import { Button } from '@lib/components'
import { Flair } from '@shamaazi/mytennights'
import { type FC } from 'react'

interface QurbaniBannerProps {
  newIcon?: boolean
  withActionButtons?: boolean
  onClickYes?: () => void
  onClickNo?: () => void
}

export const QurbaniBanner: FC<QurbaniBannerProps> = ({ newIcon = false, withActionButtons = false, onClickYes, onClickNo }) => {
  return <div className='bg-mtd-blue-1 w-full p-6 pb-8 flex flex-col gap-y-5 rounded-3xl qurbani-bg-image bg-cover bg-no-repeat bg-center'>
      <div className='flex justify-between items-center'>
        <h1 className='text-white text-qurbani-banner-h1 font-extrabold'>SET UP YOUR QURBANI!</h1>
        {newIcon && <div className="bg-mtd-yellow px-6 py-3 rounded flex items-center rounded-lg gap-x-2">
          <span className="text-mtd-secondary text-mtd-h3 font-bold leading-none">NEW</span>
          <Flair size={19} color="#364D85" />
        </div>}
      </div>
      <p className='text-white text-mtd-label font-semibold'>
        Enhance your Dhul Hijjah this year by adding Qurbani to your subscription.
        <br />
        Through Qurbani, those less fortunate can share in the joy of Eid al-Adha celebrations. Your Qurbani donation brings happiness to those most in need.
      </p>
      <p className='text-white text-mtd-info font-normal'>
        Tips will be applied to your Qurbani donation
      </p>
      {withActionButtons && onClickYes && onClickNo && <div className='flex items-center justify-end gap-x-4'>
        <Button onClick={onClickNo} variant="mtd-white-outline" className="text-mtd-h4 font-bold hover:bg-white hover:text-mtd-blue-1">No, thank you</Button>
        <Button onClick={onClickYes} variant="mtd-outline" className="text-mtd-h2 text-mtd-indigo font-bold hover:bg-mtd-secondary-1"><p>Yes, I would like to add Qurbani!</p></Button>
      </div>}
    </div>
}
